import { Item } from '@app/modules/items';

import { User } from '../users';

export interface TimerRaffleCard {
  days: [string, number],
  hours: [string, number],
  minutes: [string, number],
  seconds: [string, number],
  isTimerZero: boolean,
}

export interface TopWinner {
  id: number;
  user: User;
  prize: {
    item: Item;
  },
  claimDeadline: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface RaffleWinner {
  claimDeadline: string;
  createdAt: string;
  id: number;
  prize: number; 
  status: number
  updatedAt: string;
  user: User;
}

export enum RaffleStatus {
  STATUS_REGISTERED = 1,
  STATUS_WON = 2,
  STATUS_WON_CLAIMED = 3,
  STATUS_NOT_STARTED = 4
}

export interface Raffle {
  id: number;
  participant: boolean;
  amountOfParticipants: number;
  endDateTime: string;
  startDateTime: string;
  status: RaffleStatus;
  winner: RaffleWinner|null;
  claimDeadline: string;
  prize: {
    item: Item;
  };
  raffle: RaffleInfo;
}

export interface UnclaimedReward {
  id: number;
  claimDeadline: string;
  prize: {
    item: Item;
  };
  raffleId: number;
  raffleIterationId: number;
  raffleIterationStatus: number;
}

export interface RaffleInfo {
  description: string;
  id: number
  scheduleDescription: string;
  timeForClaimPrizeInHours: number;
  title: string;
  color: string|null;
}

export interface RaffleInvalidParam {
  key: string,
  message: string,
}

export namespace ApiResponse {
  export interface RafflesList {
    raffles: Raffle[];
  }

  export interface UnclaimedRewardsList {
    unclaimedRewards: UnclaimedReward[];
  }

  export interface ParticipantJoined {
    success: boolean;
    data: {
      participant: {
        id: number;
        user: User;
        claimDeadline: boolean;
        status: RaffleStatus;
        createdAt: string;
        updatedAt: string|null;
      }
    };
  }

  export interface TopWinners {
    winners: TopWinner[];
  }
}

export namespace WsEvents {
  export interface onWsSetCanceledRaffle {
    raffleId: number;
    raffleIterationId: number;
  }
  export interface UpdateParticipants {
    participantsAmount: number;
    raffleId: number;
    raffleIterationId: number;
  }
  export interface WinnerAnnounce {
    raffleId: number;
    iterationId: number;
    winner: {
      claimDeadline:string
      createdAt: string;
      id: number;
      status: number;
      updatedAt: string;
      user: User;
      prize: number; 
    }
  }
}

